<template>
  <div id="app">
    <div style="margin:0 auto;text-align:left;padding:0px 16px">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return {
      queryParams: {
        lang: 'zh'
      }
    }
  },
  created(){
    this.getQueryParams().then(params =>{
      if (params.lang === undefined) {
        params.lang = 'zh'
      }
      document.title=params?.lang ==='zh'? 'AI库问题解答' : 'FAQ of AICOOL';
    })
  },
  mounted() {
    document.title=this.queryParams?.lang ==='zh'? 'AI库问题解答' : 'FAQ of AICOOL';
  },
  methods:{
    getQueryParams() {
      return new Promise((resolve) => {
        const params = {};
        const queryString = window.location.search.substring(1);
        const pairs = queryString.split("&");
        for (let pair of pairs) {
          const [key, value] = pair.split("=");
          params[decodeURIComponent(key)] = decodeURIComponent(value);
        }
        this.queryParams = params;
        resolve(params);
      });
    },
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background: linear-gradient(180deg, #F9EAE7 17%, #FCF9F7 70%, #F5F5F5 100%); */
  background: #F5F5F5;
  height: 100vh;
  
}
*{
    margin: 0;
    padding: 0;
}
</style>
